import { IconProps } from 'src/utils/icon';

const PenIcon: React.FC<IconProps> = ({ size = 1, fill = '#2C2A29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.95022 2.54933L11.4508 6.04987L3.84948 13.6512L0.728461 13.9957C0.310649 14.0419 -0.0423593 13.6886 0.00412509 13.2708L0.351391 10.1476L7.95022 2.54933ZM13.6158 2.02815L11.9722 0.384521C11.4595 -0.128174 10.628 -0.128174 10.1153 0.384521L8.56901 1.93081L12.0696 5.43136L13.6158 3.88507C14.1285 3.3721 14.1285 2.54085 13.6158 2.02815Z"
      fill={fill}
    />
  </svg>
);

export default PenIcon;
